module.exports = __webpack_public_path__ + "img/gear-wide-connected.7569b5bf.svg";